import { PlayerColor } from '@colonist/game-states';
import { EnumUtils } from '@colonist/utils';
import { editProfileIdMap } from '@colonist/clientforge';
import { StoreItemCategory } from '../../../../../shared/entity_datas/StoreEnums.ts';
import { StoreItemController } from '../../../../../shared/store/StoreItemController.ts';
import { UIImagePathController } from '../../UIEnums.ts';
import { getLobbyImagePath } from '../../ui_utils/Utils.ts';
export const buildColorOptions = (availableColors)=>{
    const colorOptions = [];
    EnumUtils.loopEnums(PlayerColor, (_, color)=>{
        if (color == PlayerColor.None) return;
        const settlementImage = UIImagePathController.getPlayerColorBuildings(color).settlement;
        const colorKey = `strings:colonistCommon.playerColors.${EnumUtils.getEnumKey(color, PlayerColor)}`;
        colorOptions.push({
            colorId: editProfileIdMap.toColorId(color),
            name: {
                key: colorKey
            },
            imageUrl: getLobbyImagePath(settlementImage),
            disabled: !availableColors.includes(color),
            freeAtStore: color == PlayerColor.Black
        });
    });
    return colorOptions;
};
export const buildAvatarOptions = (ownedIconTypes)=>{
    const allIcons = StoreItemController.getItemsInCategory(StoreItemCategory.Icon, false);
    return allIcons.map((icon)=>{
        const ownsIcon = ownedIconTypes.includes(icon.type);
        return {
            avatarId: editProfileIdMap.toAvatarId(icon.type),
            name: icon.name,
            imageUrl: getLobbyImagePath(icon.image),
            disabled: !ownsIcon
        };
    });
};
export const getSelectedAvatarId = (icon)=>{
    const allIcons = StoreItemController.getItemsInCategory(StoreItemCategory.Icon, false);
    const selectedIcon = allIcons.find((storeIcon)=>storeIcon.image == icon);
    if (selectedIcon == undefined) return undefined;
    return editProfileIdMap.toAvatarId(selectedIcon.type);
};
